import { image } from 'services'
import { colors, fonts } from 'theme'
import { fontSizes } from 'theme/fonts'
import measurements from '../../app/theme/measurements'
import css from 'styled-jsx/css'
import { dropDownProps } from '../../controls/DropDown/styles'

export const hero = css`
  .hero-container {
    height: calc(90vh);
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position-x: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .hero-container.esp {
    text-aling:center;
  }
  .hero-container.esp:before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 68%;
    z-index: 0;
    opacity: 0.2;
    background: black;
    background-size: cover;
    height: calc(68vh);
  }

  .hero-container.solid-hero {
    padding-top: 2.5rem;
    background-color: ${colors.heroBg};
    min-height: 22rem;
    height: fit-content;
    box-shadow:  inset 0rem 10rem 8rem -7rem ${colors.alpha(colors.black, 0.5)};
  }
  
  .text {
    color: ${colors.white};
    line-height: 3rem;
    font: ${fonts.bold};
    max-width: 1000px;
  }

  .text.primary {
    font: ${fonts.semiBold};
    font-size: ${fontSizes.h1};
  }
  .text.secondary {
    margin: 0 0 1rem;
    font-size: ${fontSizes.body};
    font-weight: 400;
  }

  .container-children {
    width: 100%;
  }

  .buttons {
    margin-top: 3rem;
    display: flex;
    flex-direction: row;
  }

  .buttons .button {
    margin: 0 1rem;
  }

  .buttons-container {
    margin-top: 3rem;
    width: 100%;
    max-width: 800px;
    display: flex;
    justify-content: center;
  }

  .buttons-container > :global(*) {
    margin-right: 2rem;
  }

  .buttons-container > :global(*:last-child) {
    margin-right: 0;
  }

  .buttons-container :global(button) {
    width: 10rem;
  }

  @media screen and (max-width: 992px) {
    .text.primary {
      text-align: center;
      font-size: 1.5rem;
      padding: 1rem;
    }
    .text.secondary {
      padding: 0.5rem 2.5rem;
      font-size: 1rem;
      text-align: center;
    }
    .buttons-container {
      align-items: center;
      flex-direction: column;
    }
    .buttons-container > :global(*) {
      margin-right: 0;
      margin-bottom: 1rem;
    }
    .buttons-padding {
      padding: 0.625rem;
    }
    .text.primary {
      padding: 0;
    }
    .buttons-container {
      margin: 0;
    }
    .hero-container.solid-hero {
      padding: 5rem 0 3rem;
    }
  }

  .hero-container {
    height: calc(68vh);
  }
  .hero-container.nexsite1-hero-srp {
    height: auto;
    margin-bottom: 3.75rem;
  }
  .hero-container.nexsite1-hero-srp header {
    margin-bottom: 1.5625rem;
    text-shadow: 0 0 0.3125rem rgba(0, 0, 0, 0.2);
  }
  .hero-container.nexsite1-hero-srp .text.secondary {
    margin-bottom: 2.1875rem;
    text-shadow: 0 0 0.3125rem rgba(0, 0, 0, 0.2);
  }
`

export const srp = css`
  .actions {
    background-color: ${colors.white};
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    max-width: 57.5rem;
    position: relative;
    border-radius: ${measurements.borderRadius};
    height: 3.5rem;
  }
  .actions,
  .up-bottons-container {
    max-width: 57.5rem;
  }
  .actions :global(.select-container) {
    margin-top: 0;
    height: 100%;
  }
  .actions :global(.dropdown-srp) {
    border-right: solid 1px ${colors.border};
  }
  .actions :global(.select-container .dropdown-srp),
  .actions :global(.select-container .suggest-places) {
    height: 100%;
    border: none;
  }
  .actions :global(.dropdown-srp.open .dropdown-srp) {
    border-right: none;
  }
  .actions :global(.dropdown-srp) {
    min-width: 16%;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  .actions
    :global(.react-selectize.bootstrap3.root-node .react-selectize-control) {
    border: none;
  }
  .actions :global(.geo-suggest-srp) {
    min-width: 68%;
    border: none;
  }
  .hero-container .actions :global(.search-button) {
    position: absolute;
    right: 0;
    width: 11rem;
    height: 3.5rem;
    border-radius: 0 ${measurements.borderRadius} ${measurements.borderRadius} 0;
  }
  .hero-container .actions :global(.suggest-places) {
    width: 24rem;
    min-width: 45%;
    margin-right: 11rem;
  }
  .hidden {
    display: none;
  }
  .up-bottons-container {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.5rem;
    width: 100%;
    margin: 0 auto 0.5rem;
  }
  @media screen and (max-width: 992px) {
    .hero-container .actions,
    .up-bottons-container {
      max-width: 90%;
      flex-direction: column;
      height: auto;
    }
    .hero-container .actions :global(.search-button) {
      position: relative;
      width: 100%;
      border-radius: 0 0 ${measurements.borderRadius}
        ${measurements.borderRadius};
        padding: 1rem;
    }
    .hero-container .actions :global(.dropdown-srp) {
      border-right: none;
    }
    .hero-container .actions :global(.suggest-places) {
      width: 100%;
      margin: 0;
    }
    .hero-container .actions :global(select.dropdown-srp),
    .hero-container .actions :global(select.suggest-places) {
      height: 3.5rem;
    }
  }
  .tt-suggestion {
    padding: 4px 70px 4px 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    color: ${colors.rent};
  }
  .tt-suggestion-level {
    font-size: 12px;
    float: right;
    color: ${colors.dirtGray};
    position: absolute;
    right: 10px;
  }
`

export const item = css`
  .item {
    color: ${dropDownProps.optionTextColor};
    font: ${fonts.medium};
    line-height: ${dropDownProps.minHeight};
    font-size: ${fontSizes.p};
    display: block;
    background: ${colors.white};
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
  }
`
